import { cn } from '@avanta/shared/utils/cn';
import { cva, type VariantProps } from 'class-variance-authority';

const countBadgeVariants = cva(
  'inline-flex shrink-0 items-center justify-center rounded-full text-xs leading-4 font-medium text-white shadow-box-sm',
  {
    variants: {
      size: {
        sm: 'size-6',
        md: 'size-7 p-1',
      },
      background: {
        red: 'bg-red-500',
      },
    },
    defaultVariants: {
      size: 'sm',
      background: 'red',
    },
  }
);

type CountBadgeProps = React.ComponentProps<'span'> & VariantProps<typeof countBadgeVariants>;

export const CountBadge = ({
  className,
  size,
  background,
  ...props
}: CountBadgeProps): React.ReactElement => (
  <span className={cn(countBadgeVariants({ size, background }), className)} {...props} />
);
